/** @jsxImportSource @emotion/react */
import { Labels } from '@zip/business-components';
import * as React from 'react';
import type { ActivationDashboardStep } from './types';
import { StepIndicator } from 'components/activation';
import * as styles from './ActivationDashboard.styles';

type StepRowProps = {
  step: ActivationDashboardStep;
};

export function StepRow({ step }: StepRowProps): React.JSX.Element {
  const isActive = step.status === 'active';
  const isCompleted = step.status === 'completed';
  const hasAction = Boolean(step.actionLabel || step.secondaryActionLabel);
  const titleClassName = isCompleted ? 'heading4' : 'heading3';

  return (
    <div
      css={styles.stepRow(isActive)}
      data-status={step.status}
      data-testid={`activation-step-${step.id}`}
    >
      <div css={styles.stepContentGroup(isActive)}>
        <StepIndicator id={step.id} status={step.status} />

        <div css={styles.stepContent}>
          <h3 className={titleClassName} css={styles.stepTitle(step.status)}>
            {step.title}
          </h3>

          {!isCompleted && step.description && (
            <p className="body2" css={styles.stepDescription}>
              {step.description}
            </p>
          )}

          {!isCompleted && step.duration && (
            <Labels.Basic
              className="body3"
              css={styles.durationLabel}
              label={step.duration}
              variant={null}
            />
          )}
        </div>
      </div>

      {hasAction && (
        <div css={styles.stepActions(isActive)}>
          {step.actionLabel && (
            <button
              className="body1"
              css={[
                styles.primaryAction,
                isActive && styles.activePrimaryAction,
              ]}
              onClick={step.onAction}
              type="button"
            >
              {step.actionLabel}
            </button>
          )}

          {!step.actionLabel && step.secondaryActionLabel && (
            <button
              className="body1"
              css={styles.secondaryAction}
              onClick={step.onSecondaryAction}
              type="button"
            >
              {step.secondaryActionLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
